import React, { Component, memo } from 'react';
import { serviceConstants } from '../../../../services/common/constants';
import { getUserAuthToken } from '../../../../services/common/util';

class QcBarcodes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            context: { componentParent: this }
        };
    }

    render() {
        const barcodes = this.props.match?.params?.barcodes
            ? this.props.match.params.barcodes.split(',')
            : [];

        return (
            <>
                <style>{`
                    @media print {
                        .barcode-page {
                            page-break-after: always;
                            page-break-inside: avoid;
                            height: 100vh;
                            padding: 15px;
                            margin: 0;
                            border: none !important;
                        }
                        
                        .barcode-page:last-child {
                            page-break-after: auto;
                        }
                    }
                    
                    @media screen {
                        .barcode-page {
                            min-height: 100vh;
                            padding: 15px;
                        }
                    }
                `}</style>

                <div className="clinic-contain" style={{ width: '100%' }}>
                    {barcodes.map((barcode, index) => (
                        <div
                            key={index}
                            className="barcode-page"
                            style={{
                                borderBottom: index < barcodes.length - 1 ? '2px dashed #ccc' : 'none'
                            }}
                        >
                            <img
                                src={
                                    serviceConstants.API_HOST_NAME +
                                    '/files/barcodeImages/' +
                                    barcode.replace(/[^a-zA-Z0-9]/g, '') +
                                    '.png?' +
                                    new Date().getTime().toString() +
                                    '&token=' +
                                    getUserAuthToken()
                                }
                                alt={`Barcode ${barcode}`}
                                style={{
                                    width: '300px',
                                    height: 'auto',
                                    margin: '10px'
                                }}
                                onError={(e) => {
                                    // Demo fallback
                                    e.target.style.display = 'none';
                                    e.target.parentElement.innerHTML += `<div style="padding: 40px; border: 2px solid #333; background: white;">${barcode}</div>`;
                                }}
                            />
                        </div>
                    ))}
                </div>
            </>
        );
    }
}

export default QcBarcodes;
